export const TRAINING_PROGRAM_COPY = {
	title: {
		add: 'Add training program',
		edit: 'Edit training program',
	},
	submit: {
		add: 'Add',
		edit: 'Save',
	},
	description:
		'List the core compliance and GMP trainings, how they are delivered, and how completion is tracked.',
	fields: {
		audienceLabel: 'Who must complete this training?',
		deliveryLabel: 'How do you deliver the training?',
		cadenceLabel: 'How often do learners complete it?',
		platformLabel: 'Which platform or tracker hosts it?',
		tracksCompletionLabel:
			'Do you track completion and reporting for this training?',
	},
	actions: {
		removeConfirmTitle: 'Remove this training program?',
		removeConfirmDescription:
			'This program will be removed from the plan. You can add it again later.',
	},
	summary: {
		platformMissing: 'Platform details missing.',
		tracked: 'Completion tracked',
		manual: 'Manual acknowledgement',
	},
}
